import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import type { DevToolsPlugin } from '../../types';
import { styles } from './environment-info.styles';

const ENV_COLORS: Record<string, string> = {
  development: '#98c379',
  sandbox: '#e5c07b',
  production: '#e06c75',
};

@customElement('acme-devtools-environment-info')
export class AcmeDevToolsEnvironmentInfo extends LitElement {
  static override styles = styles;

  override render() {
    const config = window.CONFIG;
    const version = window.VERSION;
    const envColor = ENV_COLORS[config?.environment] ?? '#abb2bf';

    return html`
      <h3 class="section-heading">Build</h3>
      ${this._row('Version', version)}

      <h3 class="section-heading">Environment</h3>
      <div class="row">
        <span class="row-label">Environment</span>
        <span class="env-badge" style="color:${envColor}">${config?.environment}</span>
      </div>

      ${this._row('API base URL', config?.B2B_API_BASE_URL)} ${this._row('Payments API', config?.PAYMENTS_API_BASE_URL)}
      ${this._row('Checkout UI', config?.CHECKOUT_BASE_URL)} ${this._row('CDN base', config?.CDN_BASE_URL)}
      ${this._row('Checkout SDK', config?.ACMETICKETING_CHECKOUT_URL)}
    `;
  }

  private _row(label: string, value: string | undefined) {
    return html`
      <div class="row">
        <span class="row-label">${label}</span>
        <span class="row-value">${value ?? '—'}</span>
      </div>
    `;
  }
}

export const environmentInfoPlugin: DevToolsPlugin = {
  id: 'environment-info',
  label: 'Environment',
  tagName: 'acme-devtools-environment-info',
};

declare global {
  interface HTMLElementTagNameMap {
    'acme-devtools-environment-info': AcmeDevToolsEnvironmentInfo;
  }
}
